<script setup>
import { ref, computed } from 'vue';

const allReviews = [
    {
        text: "Super communauté à Lyon ! J'ai rencontré des personnes géniales lors des afterworks. Ambiance conviviale et bienveillante.",
        author: "Julien",
        rating: 5
    },
    {
        text: "QG MECS a vraiment changé ma vie sociale. Les événements sont toujours bien organisés et l'ambiance est au top !",
        author: "Marc",
        rating: 5
    },
    {
        text: "Une plateforme parfaite pour rencontrer de nouvelles personnes et participer à des événements sympas. Je recommande à 100% !",
        author: "Alexandre",
        rating: 5
    },
    {
        text: "Enfin un réseau social gay qui propose de vraies rencontres ! Les soirées sont toujours réussies et les gens sont authentiques.",
        author: "Pierre",
        rating: 5
    },
    {
        text: "Excellent pour créer des liens. J'ai trouvé un groupe d'amis formidable grâce à QG MECS. Merci pour cette belle initiative !",
        author: "Thomas",
        rating: 5
    },
    {
        text: "Les voyages organisés sont incroyables ! J'ai participé au dernier week-end et c'était une expérience inoubliable.",
        author: "Lucas",
        rating: 5
    },
    {
        text: "Une communauté où on se sent vraiment bien. Pas de jugement, que de la bonne humeur et des rencontres sincères.",
        author: "Antoine",
        rating: 5
    },
    {
        text: "Je suis membre depuis 6 mois et je ne regrette rien. Les afterworks du vendredi sont devenus mon rendez-vous incontournable !",
        author: "Maxime",
        rating: 5
    },
    {
        text: "QG MECS, c'est bien plus qu'un site de rencontres. C'est une vraie tribu où chacun trouve sa place. Bravo !",
        author: "Kevin",
        rating: 5
    }
];

const currentSlide = ref(0);
const totalPages = Math.ceil(allReviews.length / 3);

const displayedReviews = computed(() => {
    const start = currentSlide.value * 3;
    return allReviews.slice(start, start + 3);
});
</script>

<template>
    <section id="reviews" class="py-20 lg:py-32 scroll-mt-32" style="background-color: #F0F5FB;">
        <div class="container mx-auto px-4">
            <!-- Section Title -->
            <h2 class="text-3xl lg:text-4xl xl:text-5xl font-bold text-center mb-16 leading-tight" data-aos="fade-up">
                Témoignage et <span class="bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">Avis</span>
            </h2>

            <!-- Reviews Slider -->
            <div class="relative max-w-6xl mx-auto mb-12">
                <div class="relative">
                    <transition name="slide" mode="out-in">
                        <div :key="currentSlide" class="grid md:grid-cols-3 gap-8">
                            <div
                                v-for="(review, index) in displayedReviews"
                                :key="index"
                                class="bg-white p-8 relative overflow-visible"
                                style="border-radius: 0 2rem 0 2rem; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);"
                                data-aos="fade-up"
                                :data-aos-delay="index * 100"
                            >
                                <!-- Quote Icon -->
                                <div class="absolute -top-6 -left-6">
                                    <img src="/images/home/quote.svg" alt="Quote" class="w-16 h-16" />
                                </div>

                            <!-- Review Text -->
                            <p class="text-gray-600 mb-6 mt-6 leading-relaxed">
                                {{ review.text }}
                            </p>

                            <!-- Author -->
                            <div class="mt-4">
                                <p class="font-bold text-gray-800 mb-2">{{ review.author }}</p>
                                <!-- Stars -->
                                <div class="flex gap-1">
                                    <svg
                                        v-for="star in review.rating"
                                        :key="star"
                                        class="w-5 h-5"
                                        fill="#FFC107"
                                        viewBox="0 0 20 20"
                                    >
                                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                    </svg>
                                </div>
                            </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="flex justify-center gap-2">
                <button
                    v-for="(dot, index) in totalPages"
                    :key="index"
                    class="w-3 h-3 rounded-full transition-all"
                    :class="index === currentSlide ? 'bg-primary' : 'bg-gray-300'"
                    @click="currentSlide = index"
                ></button>
            </div>
        </div>
    </section>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
    transition: all 0.4s ease;
}

.slide-enter-from {
    opacity: 0;
    transform: translateX(50px);
}

.slide-leave-to {
    opacity: 0;
    transform: translateX(-50px);
}
</style>
